import {Component, Input, OnInit} from '@angular/core';
import {Order} from '../../../classes/Order';
import {OrderService} from '../../../services/order.service';
import {PaymentService} from '../../../services/payment.service';
import {OrdersView} from '../../../enums/OrdersView';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {VisitorsEditComponent} from '../../visitors/visitors-edit/visitors-edit.component';
import {LocalStorageService} from '../../../services/local-storage.service';
import {User} from '../../../classes/User';

@Component({
  selector: 'app-order-list',
  styleUrls: ['./order-list.component.scss'],
  templateUrl: './order-list.component.html',
})
export class OrderListComponent implements OnInit {

  @Input() ordersView: OrdersView;

  public orders: Order[];
  private currentDialog = null;
  public currentUser: User;
  public isAdmin: boolean;
  public isLoggedIn = false;
  private roles: string[];

  constructor(private orderService: OrderService,
              private paymentService: PaymentService,
              private modalService: NgbModal,
              private localStorageService: LocalStorageService) {}

  public ngOnInit(): void {
    this.currentUser = this.localStorageService.getUser();
    this.isLoggedIn = !!this.localStorageService.getToken();

    if (this.isLoggedIn) {
      this.roles = this.currentUser.roles;
      this.isAdmin = this.roles.includes('ROLE_ADMIN');
    }
    this.refreshList();
  }

  private refreshList(): void {
    this.orderService.getOrders(this.ordersView)
      .subscribe((response: Order[]) => this.orders = response);
  }

  public async orderCheckout(orderId: number, duration: number, orderType: string): Promise<void> {
    return this.paymentService.orderCheckout(orderId, duration, orderType);
  }

  public orderCancel(id: number): void {
    this.orderService.cancelOrder(id).subscribe(
      () => this.refreshList(),
    );
  }

  public orderMonthSubscribeCancel(id: number): void {
    this.orderService.cancelOrderMonthSubscribe(id).subscribe(
      () => this.refreshList(),
    );
  }

  public async invoice(id): Promise<void> {
    return this.paymentService.invoice(id);
  }

  openEditModal(order: Order): void {
    this.currentDialog = this.modalService.open(VisitorsEditComponent, {
      scrollable: true,
      windowClass: 'modal-visitor-edit',
      size: 'lg',
      centered: true,
    });

    this.currentDialog.componentInstance.order = order;

    this.currentDialog.result.then(
      (result) => {
        // Handle the result if necessary
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }
}
